import { RefObject } from "react";

export const scrollToTop = (
  ref?: RefObject<HTMLElement>,
  behavior: ScrollBehavior = "auto"
): void => {
  const scrollOptions = {
    top: 0,
    left: 0,
    behavior,
  };
  if (window || ref?.current) {
    ref?.current
      ? ref.current.scroll(scrollOptions)
      : window.scroll(scrollOptions);
  }
};
